// NOTE: This file is not used

import type { NativeStackNavigationProp } from "@react-navigation/native-stack";
import React from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";

import SelectOptionScreen from "../components/SelectOptionScreen";
import { commonStyles, Routes } from "../constants";

type ParamList = {
  AddMainGoalScreen: undefined;
  ProfileStartScreen: undefined;
};
type Props = {
  navigation: NativeStackNavigationProp<ParamList, "AddMainGoalScreen">;
};

const optionsData = [
  {
    id: 0,
    label: "Gain weight",
    description: "Focus on building muscle",
  },
  {
    id: 1,
    label: "Lose weight",
    description: "Focus on losing fat",
  },
  {
    id: 2,
    label: "Maintain weight",
    description: "",
  },
];

const AddMainGoalScreen = ({ navigation }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <View style={commonStyles.container}>
      <SelectOptionScreen
        pageTitle={"Your goal"}
        optionsData={optionsData}
        buttonText={"Next"}
        onButtonPress={() => {
          navigation.push(Routes.AddMotivationGoalScreen as keyof ParamList);
        }}
        multipleSelectionsAllowed={false}
        // FIXME:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        navigation={navigation}
      />
    </View>
  );
};

export default AddMainGoalScreen;
